
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {FirewallRuleModifyResponse} from './FirewallRuleModifyResponse';
import {FirewallActionType} from '../core/FirewallActionType';
import {FieldModelFirewallActionType} from '../core/FirewallActionType';
import {IPv4Range} from '../core/IPv4Range';
import {FieldModelIPv4Range} from '../core/IPv4Range';

/**
 * FirewallRuleModifyRequest struct
 */
class FirewallRuleModifyRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {UUID=} firewallRuleId
   * @param {string=} firewallRuleName
   * @param {number=} newSortOrder
   * @param {string=} newName
   * @param {string=} newDescription
   * @param {FirewallActionType=} newFirewallActionType
   * @param {IPv4Range=} newIPv4Range
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), firewallRuleId = null, firewallRuleName = null, newSortOrder = null, newName = null, newDescription = null, newFirewallActionType = null, newIPv4Range = null) {
    super()
    super.copy(parent)
    this.FirewallRuleId = firewallRuleId
    this.FirewallRuleName = firewallRuleName
    this.NewSortOrder = newSortOrder
    this.NewName = newName
    this.NewDescription = newDescription
    this.NewFirewallActionType = newFirewallActionType
    this.NewIPv4Range = newIPv4Range
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FirewallRuleModifyRequest}
   * @param {!FirewallRuleModifyRequest} other Other struct
   * @returns {!FirewallRuleModifyRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.FirewallRuleId != null) {
      this.FirewallRuleId = new UUID(other.FirewallRuleId)
    } else {
      this.FirewallRuleId = null
    }
    if (other.FirewallRuleName != null) {
      this.FirewallRuleName = other.FirewallRuleName
    } else {
      this.FirewallRuleName = null
    }
    if (other.NewSortOrder != null) {
      this.NewSortOrder = other.NewSortOrder
    } else {
      this.NewSortOrder = null
    }
    if (other.NewName != null) {
      this.NewName = other.NewName
    } else {
      this.NewName = null
    }
    if (other.NewDescription != null) {
      this.NewDescription = other.NewDescription
    } else {
      this.NewDescription = null
    }
    if (other.NewFirewallActionType != null) {
      this.NewFirewallActionType = FirewallActionType.fromObject(other.NewFirewallActionType)
    } else {
      this.NewFirewallActionType = null
    }
    if (other.NewIPv4Range != null) {
      this.NewIPv4Range = IPv4Range.fromObject(other.NewIPv4Range)
    } else {
      this.NewIPv4Range = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FirewallRuleModifyRequest}
   * @returns {!FirewallRuleModifyRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FirewallRuleModifyRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FirewallRuleModifyRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FirewallRuleModifyRequest}
   * @param {!FirewallRuleModifyRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FirewallRuleModifyRequest)) {
      throw new TypeError('Instance of FirewallRuleModifyRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FirewallRuleModifyRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      FirewallRuleId: ((this.FirewallRuleId != null) ? this.FirewallRuleId.toString() : null),
      FirewallRuleName: ((this.FirewallRuleName != null) ? this.FirewallRuleName : null),
      NewSortOrder: ((this.NewSortOrder != null) ? this.NewSortOrder : null),
      NewName: ((this.NewName != null) ? this.NewName : null),
      NewDescription: ((this.NewDescription != null) ? this.NewDescription : null),
      NewFirewallActionType: ((this.NewFirewallActionType != null) ? this.NewFirewallActionType : null),
      NewIPv4Range: ((this.NewIPv4Range != null) ? this.NewIPv4Range : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FirewallRuleModifyRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FirewallRuleModifyRequest} other Object value
   * @returns {!FirewallRuleModifyRequest} Created struct
   */
  static fromObject (other) {
    return new FirewallRuleModifyRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FirewallRuleModifyRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FirewallRuleModifyRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FirewallRuleModifyRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6549
  }
}

export { FirewallRuleModifyRequest };

/**
 * Fast Binary Encoding FirewallRuleModifyRequest field model
 */
class FieldModelFirewallRuleModifyRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.FirewallRuleId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.FirewallRuleName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.FirewallRuleId.fbeOffset + this.FirewallRuleId.fbeSize), buffer, this.FirewallRuleId.fbeOffset + this.FirewallRuleId.fbeSize)
    this.NewSortOrder = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.FirewallRuleName.fbeOffset + this.FirewallRuleName.fbeSize), buffer, this.FirewallRuleName.fbeOffset + this.FirewallRuleName.fbeSize)
    this.NewName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize), buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize)
    this.NewDescription = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewName.fbeOffset + this.NewName.fbeSize), buffer, this.NewName.fbeOffset + this.NewName.fbeSize)
    this.NewFirewallActionType = new fbe.FieldModelOptional(new FieldModelFirewallActionType(buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize), buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize)
    this.NewIPv4Range = new fbe.FieldModelOptional(new FieldModelIPv4Range(buffer, this.NewFirewallActionType.fbeOffset + this.NewFirewallActionType.fbeSize), buffer, this.NewFirewallActionType.fbeOffset + this.NewFirewallActionType.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.FirewallRuleId.fbeSize + this.FirewallRuleName.fbeSize + this.NewSortOrder.fbeSize + this.NewName.fbeSize + this.NewDescription.fbeSize + this.NewFirewallActionType.fbeSize + this.NewIPv4Range.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.FirewallRuleId.fbeExtra + this.FirewallRuleName.fbeExtra + this.NewSortOrder.fbeExtra + this.NewName.fbeExtra + this.NewDescription.fbeExtra + this.NewFirewallActionType.fbeExtra + this.NewIPv4Range.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFirewallRuleModifyRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6549
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FirewallRuleId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FirewallRuleId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallRuleId.fbeSize

    if ((fbeCurrentSize + this.FirewallRuleName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FirewallRuleName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallRuleName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDescription.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewFirewallActionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewFirewallActionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewFirewallActionType.fbeSize

    if ((fbeCurrentSize + this.NewIPv4Range.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewIPv4Range.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIPv4Range.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!FirewallRuleModifyRequest} fbeValue Default value, defaults is new FirewallRuleModifyRequest()
   * @returns {!FirewallRuleModifyRequest} FirewallRuleModifyRequest value
   */
  get (fbeValue = new FirewallRuleModifyRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!FirewallRuleModifyRequest} fbeValue FirewallRuleModifyRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FirewallRuleId.fbeSize) <= fbeStructSize) {
      fbeValue.FirewallRuleId = this.FirewallRuleId.get()
    } else {
      fbeValue.FirewallRuleId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallRuleId.fbeSize

    if ((fbeCurrentSize + this.FirewallRuleName.fbeSize) <= fbeStructSize) {
      fbeValue.FirewallRuleName = this.FirewallRuleName.get()
    } else {
      fbeValue.FirewallRuleName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FirewallRuleName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.NewSortOrder = this.NewSortOrder.get()
    } else {
      fbeValue.NewSortOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) <= fbeStructSize) {
      fbeValue.NewName = this.NewName.get()
    } else {
      fbeValue.NewName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) <= fbeStructSize) {
      fbeValue.NewDescription = this.NewDescription.get()
    } else {
      fbeValue.NewDescription = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewFirewallActionType.fbeSize) <= fbeStructSize) {
      fbeValue.NewFirewallActionType = this.NewFirewallActionType.get()
    } else {
      fbeValue.NewFirewallActionType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewFirewallActionType.fbeSize

    if ((fbeCurrentSize + this.NewIPv4Range.fbeSize) <= fbeStructSize) {
      fbeValue.NewIPv4Range = this.NewIPv4Range.get()
    } else {
      fbeValue.NewIPv4Range = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIPv4Range.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {!FirewallRuleModifyRequest} fbeValue FirewallRuleModifyRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFirewallRuleModifyRequest}
   * @param {FirewallRuleModifyRequest} fbeValue FirewallRuleModifyRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.FirewallRuleId.set(fbeValue.FirewallRuleId)
    this.FirewallRuleName.set(fbeValue.FirewallRuleName)
    this.NewSortOrder.set(fbeValue.NewSortOrder)
    this.NewName.set(fbeValue.NewName)
    this.NewDescription.set(fbeValue.NewDescription)
    this.NewFirewallActionType.set(fbeValue.NewFirewallActionType)
    this.NewIPv4Range.set(fbeValue.NewIPv4Range)
  }
}

export { FieldModelFirewallRuleModifyRequest };

/**
 * Fast Binary Encoding FirewallRuleModifyRequest model
 */
class FirewallRuleModifyRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFirewallRuleModifyRequest(this.buffer, 4)
  }

  /**
   * Get the FirewallRuleModifyRequest model
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!FieldModelFirewallRuleModifyRequest} model FirewallRuleModifyRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FirewallRuleModifyRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFirewallRuleModifyRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FirewallRuleModifyRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FirewallRuleModifyRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FirewallRuleModifyRequestModel}
   * @param {!FirewallRuleModifyRequest} value FirewallRuleModifyRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FirewallRuleModifyRequestModel}
   * @param {!FirewallRuleModifyRequest} value FirewallRuleModifyRequest value, defaults is new FirewallRuleModifyRequest()
   * @return {!object} Deserialized FirewallRuleModifyRequest value and its size
   */
  deserialize (value = new FirewallRuleModifyRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FirewallRuleModifyRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FirewallRuleModifyRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FirewallRuleModifyRequestModel}
   * @param {!number} prev Previous FirewallRuleModifyRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FirewallRuleModifyRequestModel };
FirewallRuleModifyRequest.__has_response = true;
FirewallRuleModifyRequest.__response_class = FirewallRuleModifyResponse;
